import { Instance } from 'mobx-state-tree';
import { OrganizationSettingsDtoModelBase } from './OrganizationSettingsDtoModel.base';

/* The TypeScript type of an instance of OrganizationSettingsDtoModel */
export interface OrganizationSettingsDtoModelType extends Instance<typeof OrganizationSettingsDtoModel.Type> {}

/* A graphql query fragment builders for OrganizationSettingsDtoModel */
export { selectFromOrganizationSettingsDto, organizationSettingsDtoModelPrimitives, OrganizationSettingsDtoModelSelector } from './OrganizationSettingsDtoModel.base';

/**
 * OrganizationSettingsDtoModel
 */
export const OrganizationSettingsDtoModel = OrganizationSettingsDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
